"use client";

import { motion } from "framer-motion";
import { FaMapMarkerAlt, FaPhoneAlt, FaClock } from "react-icons/fa";
export default function ContactSection() {
  return (
    <section className="relative py-24 bg-white overflow-hidden">

      {/* 🌤 About-style soft glow background */}
      <div className="absolute inset-0">
        <div className="absolute top-[-160px] left-1/2 -translate-x-1/2 w-[650px] h-[650px] bg-blue-100/60 blur-[140px] rounded-full" />
        <div className="absolute bottom-[-160px] left-[-120px] w-[450px] h-[450px] bg-indigo-100/50 blur-[120px] rounded-full" />
        <div className="absolute bottom-[-160px] right-[-120px] w-[450px] h-[450px] bg-sky-100/50 blur-[120px] rounded-full" />
      </div>

      <div className="relative max-w-6xl mx-auto px-6">

        {/* Heading */}
        <div className="text-center mb-14">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900">
            Get In Touch
          </h2>
          <p className="text-gray-500 mt-4">
            Fast response • Professional HVAC service • 24/7 support
          </p>
        </div>

        {/* Grid */}
        <div className="grid md:grid-cols-2 gap-10 items-center">

          {/* LEFT INFO */}
          <motion.div
            initial={{ opacity: 0, x: -40 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6 }}
          >

            <h3 className="text-2xl font-bold text-gray-900">
              Need HVAC Support?
            </h3>

            <p className="text-gray-500 mt-4 leading-relaxed">
              We provide installation, repair, and maintenance services for residential
              and commercial HVAC systems with fast response and reliable technicians.
            </p>

           <div className="mt-8 space-y-4 text-gray-600">

  <div className="flex items-center gap-3">
    <FaMapMarkerAlt className="text-[#0052A4] text-lg" />
    <p>Service Area: All Major Cities</p>
  </div>

  <div className="flex items-center gap-3">
    <FaPhoneAlt className="text-[#0052A4] text-lg" />
    <p>+92 321 4435 667
      <br></br>
      +92 316 4928 092</p>
  </div>

  <div className="flex items-center gap-3">
    <FaClock className="text-[#0052A4] text-lg" />
    <p>Response Time: Within Hours</p>
  </div>

</div>

            <div className="mt-8 flex gap-4">

              <a
              
                href="https://api.whatsapp.com/send?phone=923214435667"
                target="_blank"
                className="px-6 py-3 bg-blue-600 text-white rounded-xl hover:bg-blue-700 transition"
              >
                Call Now
              </a>

              <a
                href="https://api.whatsapp.com/send?phone=923164928092"
                target="_blank"
                className="px-6 py-3 border border-gray-300 text-gray-700 rounded-xl hover:bg-gray-100 transition"
              >
                WhatsApp
              </a>

            </div>
          </motion.div>

          {/* RIGHT FORM */}
          <motion.div
            initial={{ opacity: 0, x: 40 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6 }}
            className="bg-white border border-gray-100 rounded-2xl p-8 shadow-sm"
          >

            <h3 className="text-xl font-semibold text-gray-900 mb-6">
              Request Service
            </h3>

            <form className="space-y-4">

              <input
                type="text"
                placeholder="Your Name"
                className="w-full p-3 rounded-lg bg-gray-50 border border-gray-200 outline-none"
              />

              <input
                type="text"
                placeholder="Phone Number"
                className="w-full p-3 rounded-lg bg-gray-50 border border-gray-200 outline-none"
              />

              <input
                type="text"
                placeholder="Service Type"
                className="w-full p-3 rounded-lg bg-gray-50 border border-gray-200 outline-none"
              />

              <textarea
                rows="4"
                placeholder="Your Message"
                className="w-full p-3 rounded-lg bg-gray-50 border border-gray-200 outline-none"
              />

              <button
                type="submit"
                className="w-full py-3 bg-blue-600 text-white rounded-xl font-semibold hover:bg-blue-700 transition"
              >
                Send Request
              </button>

            </form>
          </motion.div>

        </div>
      </div>
    </section>
  );
}